import React from "react";
import {Box, Chip, Typography} from "@mui/material";
import {grey} from "@mui/material/colors";

import {TAG_COLORS} from "../../helpers/MemberTagHelper";

const styles = {
    tagsContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '0.25rem',
    },
    tagChip: {
        height: 'auto',
        padding: '0.2rem 0.2rem',
        backgroundColor: grey[300],
        '& .MuiChip-label': {
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem'
        }
    },
    tagLabelBox: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem'
    },
    tagLabelText: {
        fontSize: '0.75rem',
        fontWeight: 400,
    },
    voteChip: (sentiment) => ({
        backgroundColor: TAG_COLORS[sentiment],
        color: 'white',
        height: '1rem',
        fontSize: '0.75rem'
    }),
    emptyStateText: {
        fontSize: '0.75rem'
    },
};

export default function CurrentTagsDisplay({currentTags, isLoading}) {
    const hasTags = !isLoading && currentTags.length > 0;

    return (
        <Box sx={styles.tagsContainer}>
            {
                isLoading
                &&
                <Typography sx={styles.emptyStateText}>Loading tags...</Typography>
            }
            {
                !hasTags && !isLoading
                &&
                <Typography sx={styles.emptyStateText}>No tags available</Typography>
            }
            {
                hasTags
                &&
                currentTags.map((tag) => (
                    <Chip
                        key={tag.id}
                        label={
                            <Box sx={styles.tagLabelBox}>
                                <Typography sx={styles.tagLabelText}>{tag.label}</Typography>
                                {
                                    tag.votes > 0
                                    &&
                                    <Chip
                                        label={tag.votes}
                                        size="small"
                                        sx={styles.voteChip(tag.sentiment)}
                                    />
                                }
                            </Box>
                        }
                        size="small"
                        sx={styles.tagChip}
                    />
                ))
            }
        </Box>
    );
}
